// Actions
const typePrefix = "chart/";
const SET = `${typePrefix}SET`;

// Selectors

export const getChart = state => state.chart;

// Action creators

/**
 *
 * @param {string} articleId the article Id to be toggled
 * @return {function} thunk action creator
 */
export const setChart = ({ chartId, groupId }) => ({
  type: SET,
  chartId,
  groupId
});

const emptyState = {
  chartId: null,
  groupId: false
};

// Reducer
export function chartReducer(state = emptyState, action = {}) {
  switch (action.type) {
    case SET:
      return {
        chartId: action.chartId,
        groupId: action.groupId
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/state/chart/index.js